import conversationApiService from '@/services/conversationApiService';

const getRequests = ({ commit }, locationId) => {
  return conversationApiService.getRequests({ locationId })
    .then((res) => {
      commit('SET_REQUESTS', res.data);
      return res;
    });
}

const getThreadDetail = ({ commit }, params) => {
  let promise;
  if (params.accessToken) {
    promise = conversationApiService.getThreadDetail(params.accessToken)
  } else {
    promise = conversationApiService.findThread(params).then(res => {
      if (res.data.length) {
        return {
          data: res.data[0]
        }
      } else {
        return {
          data: null
        }
      }
    });
  }
  return promise
    .then((res) => {
      commit('SET_THREAD', res.data);
      return res;
    });
}

const getThreadMessages = ({ commit }, accessToken) => {
  return conversationApiService.getThreadMessages(accessToken)
    .then((res) => {
      commit('SET_THREAD_MSGS', res.data);
      return res;
    });
}

const postMessage = ({ commit }, { accessToken, message }) => {
  return conversationApiService.postMessage({ accessToken, message })
    .then((res) => {
      commit('UPDATE_THREAD_MSGS', res.data);
      return res;
    });
}

const postThread = ({ commit }, thread) => {
  return conversationApiService.postThread(thread)
    .then((res) => {
      commit('SET_THREAD', res.data);
      res.data.serviceCase.messageAccessToken = res.data.messageAccessToken;
      commit('serviceCase/SET_CASE', res.data.serviceCase, { root: true });
      commit('SET_THREAD_MSGS', [res.data.lastMessage]);
      return res;
    });
}

export default {
  getRequests,
  getThreadDetail,
  getThreadMessages,
  postMessage,
  postThread
};
